class PrdDisplay {
	constructor() {
		this.init()
	}

	init() {
		this.bindEvents()
		this.checkLocalStorage()
		this.prdDisplayCartItems()
	}

	bindEvents() {
		yTos.watch({
			'yTos::Product::ProductAddedToShoppingBag': this.setCartItemLocalStorage.bind(this),
			'CAR::ADD_TO_CART': this.setCartItemLocalStorage.bind(this),
		})
	}

	checkLocalStorage() {
		if (!window.tc_vars?.cart_items.length && !window.tc_vars?.order_items.length) {
			localStorage.removeItem('cart_items')

			yTos.notify('CAR:LocalStorage:RemoveItem')
		}
	}

	setCartItemLocalStorage(data) {
		const cartItemStorage = this.getCartItemLocalStorage()

		const orderItemIds = this.getDataCartItemIds(data)
		if (orderItemIds.length) {
			orderItemIds.forEach((orderItemId) => {
				cartItemStorage[orderItemId] = window.tc_vars?.prddisplay
			})

			localStorage.setItem('cart_items', JSON.stringify(cartItemStorage))
			yTos.notify('CAR:LocalStorage:setItem')
		}
	}

	getDataCartItemIds(data) {
		if (!data.dataCart) {
			const fragment = document.createRange().createContextualFragment(data.content)
			const div = fragment.querySelector('div')

			return JSON.parse(div.getAttribute('data-ytos-operation-result')).OrderItemIds ?? []
		}

		return data.dataCart.orderItemIds ? data.dataCart.orderItemIds : data.dataCart
	}

	deleteItemLocalStore(orderItemIds) {
		const cartItemStorage = this.getCartItemLocalStorage()
		if (orderItemIds.length) {
			orderItemIds.forEach((orderItemId) => {
				delete cartItemStorage[orderItemId]
			})
		}
		if (Object.keys(cartItemStorage).length) {
			localStorage.setItem('cart_items', JSON.stringify(cartItemStorage))
		} else {
			localStorage.removeItem('cart_items')
		}
	}

	getCartItemLocalStorage() {
		const cartItemStorage = localStorage.getItem('cart_items')

		if (cartItemStorage) {
			return JSON.parse(cartItemStorage)
		}
		return {}
	}

	prdDisplayCartItems() {
		if (window.tc_vars?.cart_items.length) {
			this.addPrdDisplayToDatalayer(window.tc_vars.cart_items, 'cart')
		}
		if (window.tc_vars?.order_items.length) {
			this.addPrdDisplayToDatalayer(window.tc_vars.order_items, 'order')
			const orderItemIds = window.tc_vars.order_items.map(
				(item) => item.order_item_orderItemId
			)
			this.deleteItemLocalStore(orderItemIds)
		}
	}

	addPrdDisplayToDatalayer(arrayItems, type) {
		if (localStorage.getItem('cart_items')) {
			const cartItem = JSON.parse(localStorage.getItem('cart_items'))

			arrayItems.forEach((item) => {
				const orderItemId =
					type === 'cart' ? item.cart_item_orderItemId : item.order_item_orderItemId
				const prDisplay = orderItemId ? cartItem[orderItemId] : ''
				if (type === 'cart') {
					item.cart_item_display = prDisplay ?? ''
				} else {
					item.order_item_display = prDisplay ?? ''
				}
			})
		}
	}
}

export default PrdDisplay
